import React from 'react';
import { useDispatch } from 'react-redux';

const PageSizeControl = ({ pageable, onPageSizeChange }) => {
  const dispatch = useDispatch();

  const handlePageSizeChange = (event) => {
    dispatch(onPageSizeChange(event.target.value));
  };

  return (
    <div className="flex items-center gap-2 w-fit">
      <div className="text-xs md:text-sm">Елементів:</div>
      <select
        value={pageable.size}
        onChange={handlePageSizeChange}
        className="text-xs md:text-sm py-1 text-bg1 border-b border-gray-300 hover:cursor-pointer focus:outline-none"
      >
        {[10, 20, 50].map((value, i) => (
          <option key={i} value={value}>
            {value}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PageSizeControl;
